<template>
  <div>
    <!-- <h5 class="title" style="">
            {{ lodash.upperCase($t('Filter')) }}
        </h5> -->
    <b-card class="border-0" no-body>
      <b-card-body style="">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title" role="button" @click="filterVisible = !filterVisible">
            FILTER
          </div>
          <div class="title" role="button" @click="resetFilter">RESET</div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('ticket_id__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('paid_at__between')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('from_bank_account.customer_id__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('payment_status')"></filter-item>
          </div>
        </div>
        <!-- <b-collapse id="filter-collapse" class="mt-2" v-model="filterVisible">
          <div class="row">
            <div class="col-md-6">
              <filter-item :filter-column="resolveComponent('id__in')"></filter-item>
            </div>
            <div class="col-md-6">
              <filter-item :filter-column="resolveComponent('customer_id__in')"></filter-item>
            </div>
          </div>
        </b-collapse> -->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ModelFilter from "@/components/model-filter-v4";

export default {
  extends: ModelFilter,
  data() {
    return {
      filterVisible: false
    };
  }
};
</script>

<style scoped>
.multiselect__content-wrapper {
  height: 1000px !important;
}

.label-filter {
  font-weight: 500;
  font-size: 14px;
  color: #6c7589;
  margin-bottom: 5px;
}
</style>
